import { render } from "./AcceptanceHistoryPageList.vue?vue&type=template&id=34c6dfb4&scoped=true"
import script from "./AcceptanceHistoryPageList.vue?vue&type=script&lang=ts"
export * from "./AcceptanceHistoryPageList.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-34c6dfb4"

export default script